import React from 'react'
import { withGlobalModal } from '../../hoc'

class ModalOpener extends React.Component {
  handleShowModal = () => {
    const { showModal, modal, modalProps } = this.props
    console.log('handle-show', { showModal, modal, modalProps })
    showModal(modal, modalProps)
  }

  render () {
    const { children } = this.props

    return {
      ...children,
      props: { ...children.props, onClick: this.handleShowModal }
    }
  }
}

export default withGlobalModal(ModalOpener)
